import { Injectable } from '@angular/core';
import { HttpClient,HttpErrorResponse, HttpParams, HttpHeaders } from '@angular/common/http';
import { Observable, throwError} from 'rxjs';
import { map,catchError,delay } from 'rxjs/operators';
import { Quotation } from '../types/quotation';
import { EnvService } from '../services/env.service';


const httpOptions= {headers: new HttpHeaders({'Content-Type':'application/json'}) };

@Injectable({
  providedIn: 'root'
})
export class QuotationService {

  
  constructor(private http: HttpClient,private env: EnvService ) { }

  getMaxId() :Observable <any[]>{
     return this.http.get<any[]>(`${this.env.apiUrl}/quotation/getMaxId`,httpOptions)
     .pipe(catchError(this.handleError));
        
     }



   getAll():Observable <Quotation[]> {
    return this.http.get <Quotation[]>(`${this.env.apiUrl}/quotation`,httpOptions)
    .pipe(catchError(this.handleError));
       
    }


    getQuotation(invoiceNo):Observable <Quotation> {
      return this.http.get<Quotation>(`${this.env.apiUrl}/quotation/${invoiceNo}`,httpOptions)
      .pipe(catchError(this.handleError));
         
      }


    addQuotation(data):Observable <any>{
      return this.http.post<any>(`${this.env.apiUrl}/quotation`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }

    updateQuotation(data):Observable <any>{
      return this.http.put<any>(`${this.env.apiUrl}/quotation`, data ,httpOptions)
        .pipe(catchError(this.handleError));
       
    }


    deleteQuotation(quotationNo) : Observable <any>{
      return this.http.delete<any>(`${this.env.apiUrl}/quotation/${quotationNo}`,httpOptions)
        .pipe(catchError(this.handleError));
       
    }



    private handleError(errorResponse: HttpErrorResponse) {
      return throwError(errorResponse || "Server Error");

      }       


}
